import { useActions, useState } from '../../../js/stores/hooks';

export const InputComposition = () => {
  const { value, units, type } = useState('input', ['value', 'units', 'type']);
  const { setInput } = useActions('input', ['setInput']);
  return { value, units, type, setInput };
}
